module.exports = __webpack_public_path__ + "img/money-error.c5c2c823.png";